<div id="infinite" class="_logo-slider">
	<div class="container _logo-container">
		<ul class="_logo-list">
			<ng-container *ngFor="let duplicate of duplicateLogos">
				<li class="_logo" *ngFor="let logo of logos">
					<img src="./assets/imgs/digibanken/{{logo}}"/>
				</li>	
			</ng-container>
		</ul>
	</div>
</div>	
